import { sceconfig } from 'sce-core';

export const environment = {
  production: true,
  baseUrlUI: sceconfig.wms.baseUrlUI,

  wmsApiBaseUrl: 'https://americas-wms.fulfillment.maersk.com/scecommon/',
  notificationApiBaseUrl: 'https://americas-tms.fulfillment.maersk.com/api',
};
